namespace Matrix.Rebalancer {
    export interface TaskTypeRow {
        TaskTypeCode?: string;
        Name?: string;
        SessionScope?: boolean;
        AutoComplete?: boolean;
        RequiresReview?: boolean;
        CanAdd?: boolean;
        DefaultProperties?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace TaskTypeRow {
        export const idProperty = 'TaskTypeCode';
        export const nameProperty = 'TaskTypeCode';
        export const localTextPrefix = 'Rebalancer.TaskType';
        export const deletePermission = 'DataAdmin:Rebalancer';
        export const insertPermission = 'DataAdmin:Rebalancer';
        export const readPermission = 'Read:Rebalancer';
        export const updatePermission = 'DataAdmin:Rebalancer';

        export declare const enum Fields {
            TaskTypeCode = "TaskTypeCode",
            Name = "Name",
            SessionScope = "SessionScope",
            AutoComplete = "AutoComplete",
            RequiresReview = "RequiresReview",
            CanAdd = "CanAdd",
            DefaultProperties = "DefaultProperties",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
